import * as React from "react";
import { useRef, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

interface ICustomScrollAreaProps {
    children?: React.ReactNode;
    shouldAutoScroll: boolean;
}

export default function CustomScrollArea({
    children,
    shouldAutoScroll,
}: ICustomScrollAreaProps) {
    const scrollbarsRef = useRef<Scrollbars | null>(null);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const handleScroll = () => {
        if (!scrollbarsRef.current) return;

        // Clear any previous timeouts
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            try {
                const activeItem = document.querySelector(
                    ".NavigationTree__item--active"
                ) as HTMLElement | null;

                if (!activeItem) return;

                const scrollView = scrollbarsRef.current!.container;
                const activeItemOffsetTop = activeItem.offsetTop;
                const activeItemHeight = activeItem.offsetHeight;
                const scrollTarget =
                    activeItemOffsetTop -
                    (scrollView.clientHeight / 3 - activeItemHeight / 2);

                scrollbarsRef.current!.scrollTop(scrollTarget);
            } catch (e) {
                console.error("Scroll error:", e);
            }
        }, 50);
    };

    // Handle auto-scroll when prop changes
    useEffect(() => {
        if (shouldAutoScroll) {
            handleScroll();
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [shouldAutoScroll]);

    return (
        <Scrollbars
            ref={scrollbarsRef}
            className="ScrollArea"
            renderTrackHorizontal={(props) => (
                <div {...props} className="ScrollArea__track--horizontal" />
            )}
            renderTrackVertical={(props) => (
                <div {...props} className="ScrollArea__track--vertical" />
            )}
            renderThumbHorizontal={(props) => (
                <div {...props} className="ScrollArea__thumb--horizontal" />
            )}
            renderThumbVertical={(props) => (
                <div {...props} className="ScrollArea__thumb--vertical" />
            )}
            renderView={(props) => (
                <div {...props} className="ScrollArea__view" />
            )}
        >
            {children}
        </Scrollbars>
    );
}
